import moment from 'moment';
import { arrayOf } from 'prop-types';
import React from 'react';

import Table from '../../generic/Table';
import { userShape } from '../../prop-types';
import withUsers from '../../users/withUsers/with-users';
import { INTERNAL_DATE_FORMAT } from '../../utils/constants';
import { toBeInvoicedColumns } from '../campaign-columns';
import dump from '../utils/dump';
import withCampaignsAsData from '../with-campaigns-as-data';

const searchParams = {
  hasInvoice: false,
  hasBillableBudget: true,
  endDatePlan_before: moment().format(INTERNAL_DATE_FORMAT),
  endDatePlan_after: '2020-07-15', // 15th July 2020
};

const ListCampaignsToBeInvoiced = withCampaignsAsData(
  ({ data, users }) => (
    <Table
      data={data}
      columns={toBeInvoicedColumns}
      minRows={1}
      pageSizeOptions={[5, 10, 20]}
      defaultPageSize={5}
      onDownload={dump ? rows => dump(rows, searchParams, users) : undefined}
    />
  ),
  true,
  searchParams,
);

ListCampaignsToBeInvoiced.propTypes = {
  users: arrayOf(userShape.isRequired).isRequired,
};

export default withUsers({})(ListCampaignsToBeInvoiced);
